import { campaigns } from './campaigns';
import { stats } from './stats';
import { worksheets } from './worksheets';
import { media } from './media';

export const autoinformer = {
  namespaced: true,
  modules: { campaigns, stats, worksheets, media }
};
